import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
class ParsedLtr {
  values = {};
  constructor(translations) {
    Object.keys(translations).forEach((key) => {
      this.values[key] = translations[key];
    });
  }
}
const LtrTag = new Type(CUSTOM_TAGS.LTR, {
  kind: "mapping",
  resolve: (data) => data !== null && typeof data !== "string",
  construct: (data) => new ParsedLtr(data),
  instanceOf: ParsedLtr,
  represent: (data) => ({ ...data.values })
});
export {
  LtrTag,
  ParsedLtr
};
